module.exports = __webpack_public_path__ + "img/view-contract.a624cb00.svg";